import { render } from "./PageNotFound.vue?vue&type=template&id=50865399"
const script = {}

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__